export const publishableKeys = {
  development:
    "pk_test_51J4mYbI6SZCrkqwIabA45IGTIDzNqehkMaUGbqzmrBQoJZJIDHKSZBp4ijfL8n6ldAfuLsiautooLlmfSBPRsCKq009nmfTvtZ",
  dev:
    "pk_test_51J4mYbI6SZCrkqwIabA45IGTIDzNqehkMaUGbqzmrBQoJZJIDHKSZBp4ijfL8n6ldAfuLsiautooLlmfSBPRsCKq009nmfTvtZ",
  production:
    "pk_live_51J4mYbI6SZCrkqwIH6eaWT1Py1JOzif5ouAIJFhqEnpaZfVrjD4ZmV4ZfP9RgHlcS1OCgQnW2796aC3vAtouGL1H00ur2jihW9"
};
